import { checker } from '@/directives'
export default {
  directives: { checker },

  data () {
    return {
      changedFlag: false
    }
  },

  methods: {
    $changedReset () {
      this.changedFlag = false
    }
  }
}
